// extracted by mini-css-extract-plugin
export default {"collapse":"lsf_collapse__8x9rr"};